
import * as React from "react";
import avatar3 from '../assets/mk3.png';

import {
    Avatar,
    Icon,
    Grid,
    Card,
    Form,
} from "tabler-react";


export default class MyProfile extends React.Component {
    render() {
        return (
            <Card>
                <Card.Header>
                    <Card.Title>My Profile</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Form>
                        <Grid.Row>
                            <Grid.Col width={12} lg={6}>
                                <Grid.Row>
                                    <Grid.Col auto>
                                        <Avatar size="xl" imageURL={avatar3} />
                                    </Grid.Col>
                                    <Grid.Col>
                                        <Form.Group>
                                            <Form.Label>Verfügbarkeit</Form.Label>
                                            <Form.Input placeholder="06.01.2020" />
                                        </Form.Group>
                                    </Grid.Col>
                                </Grid.Row>
                                <Form.Group>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Input placeholder="Mahmut Keygubatli" />
                                </Form.Group>
                            </Grid.Col>
                            <Grid.Col width={12} lg={6}>

                                <Form.Group>
                                    <Form.Label>Anschrift</Form.Label>
                                    <Form.Textarea rows={4}>
                                        {"Hünefeld Str. 5\n44369 Dortmund"}
                                    </Form.Textarea>
                                </Form.Group>
                            </Grid.Col>
                            <Grid.Col width={12} lg={6}>
                                <Form.Group>
                                    <Form.Label>Mobilnummer</Form.Label>
                                    <Form.Input placeholder="0171 / 833 1495" />
                                </Form.Group>
                            </Grid.Col>
                            <Grid.Col width={12} lg={6}>
                                <Form.Group>
                                    <Form.Label>Email-Address</Form.Label>
                                    <Form.Input placeholder="mahmut.keygubatli@areaway.de" />
                                </Form.Group>
                            </Grid.Col>
                            <Grid.Col width={12} lg={6}>
                                <Form.Group>
                                    <Form.Label>Studienabschluss</Form.Label>
                                    <Form.Textarea rows={2}>
                                        {"Diplom Informatiker 1997\nan der TU Dortmund"}
                                    </Form.Textarea>
                                </Form.Group>
                            </Grid.Col>
                            <Grid.Col width={12} lg={6}>
                                <Form.Group>
                                    <Form.Label>Schulabschluss</Form.Label>
                                    <Form.Textarea rows={2}>
                                        {"Abitur 1989\nam Reinoldus-Schiller Gymnasium"}
                                    </Form.Textarea>
                                </Form.Group>
                            </Grid.Col>
                            <Grid.Col width={12} lg={6}>
                                <Form.Group label="Zertifizierungen">
                                    <Form.SelectGroup
                                        canSelectMultiple
                                        pills
                                    >
                                        <Form.SelectGroupItem
                                            label="SCJP"
                                            name="language"
                                            value="SCJP"
                                        />
                                        <Form.SelectGroupItem
                                            label="MCP"
                                            name="language"
                                            value="MCP"
                                        />
                                    </Form.SelectGroup>
                                </Form.Group>
                            </Grid.Col>
                            <Grid.Col width={12} lg={6}>
                                <Form.Group label="Sprachkenntnisse">
                                    <Form.SelectGroup
                                        canSelectMultiple
                                        pills
                                    >
                                        <Form.SelectGroupItem
                                            label="Deutsch"
                                            name="language"
                                            value="Deutsch"
                                        />
                                        <Form.SelectGroupItem
                                            label="Englisch"
                                            name="language"
                                            value="Englisch"
                                        />
                                        <Form.SelectGroupItem
                                            label="Türkisch"
                                            name="language"
                                            value="Türkisch"
                                        />
                                    </Form.SelectGroup>
                                </Form.Group>
                            </Grid.Col>
                            <Grid.Col width={12} lg={6}>
                                <Form.Group label="Kontakt">
                                    <Form.SelectGroup pills>
                                        <Form.SelectGroupItem
                                            label={<Icon prefix="fa" name="envelope-o" />}
                                            name="weather"
                                            value="sun"
                                        />
                                        <Form.SelectGroupItem
                                            label={<Icon prefix="fa" name="xing" />}
                                            name="weather"
                                            value="sun"
                                        />
                                        <Form.SelectGroupItem
                                            label={<Icon prefix="fa" name="linkedin" />}
                                            name="weather"
                                            value="sun"
                                        />
                                    </Form.SelectGroup>
                                </Form.Group>

                            </Grid.Col>
                        </Grid.Row>
                    </Form>
                </Card.Body>
            </Card>
        )
    }
}

/*
class Intro extends React.Component<HelloMessageProps, {}>{
    render() {
        return (
            <Profile
                name="Mahmut Keygubatli"
                backgroundURL={backgroungImg}
                avatarURL={avatar1}
                twitterURL="test"
            >
                very experienced programmer and web developer
        </Profile>
        )
    }
}
*/